<template>
  <div class="container" v-if="item">
    <h1>
      {{ item.name || 'Spell' }}
      <router-link class="btn btn-primary btn-sm pull-right" :to="`/spells/${item._id}/edit`" v-if="canEdit">
        Edit
      </router-link>
      <button v-else class="btn btn-success btn-sm pull-right" @click="cloneData()">Clone</button>
    </h1>
    <hr>

    <h5 v-if="item.level === 0" class="level">
      {{item.school}} cantrip
    </h5>
    <h5 v-else-if="item.rank" class="level">
      {{item.rank}}
      <span v-if="!['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset) && item.school">{{lowerCase(item.school)}}</span>
    </h5>
    <h5 v-else-if="item.level || item.school" class="level">
      {{item.level}}<!--
      --><span v-if="item.level === 1">st</span><!--
      --><span v-else-if="item.level === 2">nd</span><!--
      --><span v-else-if="item.level === 3">rd</span><!--
      --><span v-else-if="item.level">th</span><!--
      --><span v-if="item.level">-level</span>
      <span v-if="!['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset) && item.school">{{lowerCase(item.school)}}</span>
    </h5>

    <div v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset) && item.actions">
      <strong>Actions</strong> 
      <span v-if="item.actions === 'F'">Free</span>
      <span v-if="item.actions === 'R'">Reaction</span>
      <span v-if="item.actions > 0 && item.actions < 4">{{item.actions}}</span>
    </div>
    
    <div v-if="classes"><strong>Class(es): </strong><span class="classes">{{classes}}</span></div>
    <div v-if="item && item.description" v-html="$embers.markdown(item.description)"></div>
    <br>
    <div v-if="item && item._parent && item._parent.name">
      <hr>
      <h3>{{item._parent.name}}</h3>
      <div id="child" v-if="item && item._parent && item._parent.description" v-html="$embers.markdown(item._parent.description)"></div>
    </div>
    <rulebook-footer :item="item"></rulebook-footer>

    <div class="row hidden-print return-to-list">
      <div class="col text-center">
        <router-link :to="`/spells#${$embers.slugify(item.name)}`"><i class="fa fa-angle-double-left"></i> Return to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import RulebookFooter from "@/components/shared/_RulebookFooter";

export default {
  name: "spell-show",
  components: {
    RulebookFooter,
  },
  watch: {
    // call again the method if the route changes
    $route: "getData",
    item: "removeChildDetail",
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({ canEdit: "spells/canEdit" }),
    ...mapState({
      item: (state) => state.spells.current,
    }),
    classes() {
      return this.item.classes.join(", ");
    },
  },
  methods: {
    ...mapActions({
      spellsRead: "spells/read",
      spellsClone: "spells/clone",
    }),
    lowerCase(value) {
      return value.toLowerCase();
    },
    removeChildDetail() {
      this.$rpgv.removeChildDetail(this);
    },
    async getData() {
      try {
        await this.spellsRead({ id: this.$route.params.id });
        this.$embers.pageData(this.item.name, this.item.summary);
      } catch (err) {
        console.error(err);
      }
    },
    async cloneData() {
      try {
        let clone = await this.spellsClone(this.spell);
        this.$router.push({ path: `/spells/${clone._id}/edit` });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

.level {
  font-style: italic;
  color: $primary;
  margin-top: -0.5rem;
}

.classes {
  text-transform: capitalize;
}
</style>
